import { last } from "lodash";
import { useEffect, useState } from "react";
import { getColorFromInitial } from "../../utils/Utils";
import { UserDetailModal } from "./UserDetailModal";
import { useImageLoader } from "../customHook/ImageLoader";
import { Avatar, Image, Spin } from "antd";
import { UserStatusCustomAvatar } from "./UserStatusCustomAvatar";

const CustomAvatar = ({
  conversationAvatar,
  person,
  size = 40,
  index,
  pos,
  styleCss = { position: "absolute" },
  isShowDetail = false,
  isShowUserStatus = { status: false, isAlwaysTrue: false },
  userId,
}) => {
  const [brieftName, setBriefName] = useState();
  const [isOpenModalUserDetail, setIsOpenModalUserDetail] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  const {
    imageUrl,
    loading: isImageLoading,
    error: imageError,
  } = useImageLoader(conversationAvatar ?? person?.avatar);

  const customStyleUserStatus = {
    borderRadius: "50%",
    position: "absolute",
    left: size < 40 ? "15px" : "26px",
    top: size < 40 ? "15px" : "26px",
    zIndex: 1,
    width: "14px",
    height: "14px",
    border: "2px solid white",
    zoom: size < 40 ? 0.7 : 1,
  };

  const handleOpenModalUserDetail = () => {
    if (!isShowDetail) return;

    setIsOpenModalUserDetail(true);
  };

  useEffect(() => {
    setBriefName(
      last(person?.name?.trim()?.split(" "))?.[0] ||
        last(person?.username?.trim()?.split(" "))?.[0] ||
        "U"
    );
  }, [person]);

  if (conversationAvatar) {
    if (imageError) {
      return (
        <Avatar
          size={size}
          style={{
            backgroundColor: getColorFromInitial(brieftName),
          }}
        >
          {brieftName}
        </Avatar>
      );
    }

    return (
      <>
        <Avatar
          src={imageUrl}
          size={size}
          style={{
            backgroundColor: "#D3E3FD",
          }}
          onClick={() => setIsPreview(true)}
        >
          {brieftName}
        </Avatar>
        {isPreview && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: isPreview,
              onVisibleChange: (visible) => setIsPreview(visible),
            }}
            src={imageUrl}
          />
        )}
      </>
    );
  }

  if (pos === -1) {
    if (imageError) {
      return (
        <div className={`relative`}>
          <Avatar
            style={{
              backgroundColor: getColorFromInitial(brieftName),
            }}
            size={size}
          >
            {brieftName}
          </Avatar>
          {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
            <UserStatusCustomAvatar
              userId={userId}
              customStyle={customStyleUserStatus}
              isAlwaysTrue={isShowUserStatus.isAlwaysTrue}
            />
          )}
        </div>
      );
    }

    if (isImageLoading) {
      return (
        <div className={`relative`}>
          <Avatar
            style={{
              backgroundColor: getColorFromInitial(brieftName),
            }}
            size={size}
            icon={<Spin />}
          >
            {brieftName}
          </Avatar>
          {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
            <UserStatusCustomAvatar
              userId={userId}
              customStyle={customStyleUserStatus}
            />
          )}
        </div>
      );
    }
  }

  return (
    <>
      <div className={`relative`}>
        <Avatar
          style={{
            ...pos,
            zIndex: 10 - index,
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: getColorFromInitial(brieftName),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            color: "#fff",
            fontWeight: 500,
            userSelect: "none",
            ...styleCss,
          }}
          size={size}
          src={imageUrl}
          className={`${isShowDetail ? "cursor-pointer" : ""}`}
          onClick={handleOpenModalUserDetail}
        >
          {brieftName}
        </Avatar>

        {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
          <UserStatusCustomAvatar
            userId={userId}
            customStyle={customStyleUserStatus}
          />
        )}
      </div>
      {isOpenModalUserDetail && (
        <UserDetailModal
          person={person}
          isOpen={isOpenModalUserDetail}
          handleCancel={() => setIsOpenModalUserDetail(false)}
        />
      )}
    </>
  );
};
export { CustomAvatar };
